"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrositeWidgetKeys = exports.WidgetType = void 0;
var WidgetType;
(function (WidgetType) {
    WidgetType["TABLE"] = "Table";
    WidgetType["NUMBER"] = "Number";
    WidgetType["NUMBERWITHUNIT"] = "NumberWithUnit";
    WidgetType["DECISION"] = "Decision";
    WidgetType["TEXT"] = "Text";
    WidgetType["LONGTEXT"] = "LongText";
    WidgetType["OMITTED"] = "Omitted";
    WidgetType["MISSING_DATA"] = "MissingData";
    WidgetType["PIE_CHART"] = "PieChart";
    WidgetType["PROGRESS_CHART"] = "ProgressChart";
})(WidgetType || (exports.WidgetType = WidgetType = {}));
exports.MicrositeWidgetKeys = {
    __typename: true,
    templateID: true,
    type: true,
    subTemplateID: false,
    organizationID: true,
    reportingPeriodID: true,
    networkID: true,
    standardID: true,
    esgCategoryID: true,
    esgCategoryOrderID: true,
    standardThemeID: true,
    standardThemeOrderID: true,
    standardSubThemeID: true,
    standardSubThemeOrderID: true,
    unitID: true,
    unitDataType: true,
    hierarchyPath: true,
    translations: true,
    matchedDisclosures: true,
    matchedDisclosureString: true,
    matchType: true,
    aggregatedData: true,
    "reportingPeriodID#standardID#matchedDisclosureString": true,
};
//# sourceMappingURL=MicrositeWidget.type.js.map